export enum LineItemClassification {
    RENTAL = 'Rental',
    SALE = 'Sale'
}
